import Cookies from "js-cookie";

export async function getobj(url) {
  let res;
  await fetch(url, {
    headers: {
      Authorization: "Token " + sessionStorage.getItem("token"),
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      //console.log(data)
      res = data;
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
  //console.log(res)
  return res;
}

export async function postobj(url, data) {
  let res;
  await fetch(url, {
    headers: {
      Authorization: "Token " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-CSRFToken": Cookies.get("csrftoken"),
    },
    method: "POST",
    body: JSON.stringify(data),
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      res = data;
      return data;
    });
  return res;
}

export async function updateobj(url, data) {
  let res = await fetch(url, {
    headers: {
      Authorization: "Token " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-CSRFToken": Cookies.get("csrftoken"),
    },
    method: "PATCH",
    body: JSON.stringify(data),
  }).then(function (r) {
      return r.json();
    })
    .then(function (data) {
      return data;
    });
  return res;
}

export async function updateObj(url, data) {
  // 1) Fire the request
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      Authorization: "Token " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-CSRFToken": Cookies.get("csrftoken"),
    },
    body: JSON.stringify(data),
  });

  // 2) Parse the JSON (this will still work if status is 4xx/5xx,
  //     but you can choose to throw on !response.ok if you like)
  const body = await response.json();

  // 3) Return both status and body
  return {
    status: response.status,
    ok: response.ok,
    data: body,
  };
}

export async function deleteobj(url) {
  let res;
  await fetch(url, {
    headers: {
      Authorization: "Token " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-CSRFToken": Cookies.get("csrftoken"),
    },
    method: "DELETE",
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      res = data;
      return data;
    });
  return res;
}

export async function dltobj(url, data) {
  let res;
  await fetch(url, {
    headers: {
      Authorization: "Token " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-CSRFToken": Cookies.get("csrftoken"),
    },
    method: "DELETE",
    body: JSON.stringify(data),
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      res = data;
      return data;
    });
  return res;
}
